import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  rules = 1,
  stars,
  fans,
}
export enum AnchorTypeEnum {
  qualifier = 1,
  track,
  knockouts,
}
// 本次活动会投放发的地区
export const areaList = [0, 1, 5, 2, 6]
export const areaChinese = {
  '0': '中东',
  '1': '印尼',
  '5': '泰国',
  '2': '越南',
  '6': '印度',
}
// 获取 赛程列表页 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27702278
export const yup_stage_list = createAsyncThunk(
  'yup_stage_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'doing_stage'>>
    >(
      '/live/activity/yup_stage_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取pk赛详情 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27702330
export const yup_pk_stage = createAsyncThunk(
  'yup_pk_stage',
  async (
    arg: {stage_id: number; group_no: number; peroid_index?: number},
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'broadcasts'
          | 'stage_range'
          | 'group_list'
          | 'group_no'
          | 'pk_list'
          | 'pk_rank'
          | 'own_rank'
          | 'peroid_list'
          | 'peroid_index'
          | 'peroid_count_down'
          | 'count_down'
        >
      >
    >('/live/activity/yup_pk_stage', {
      ...arg,
      offset: 0,
      page_size: 10,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface HiyaRes<T> {
  ret: number
  data: T
}

export interface ScheduleType {
  name: string
  start_date: string
  end_date: string
  // 比赛持续时间
  duration: number
  stage_range: Array<string>
  stage_id: number
  // 赛程状态: 0: 未开始;1:进行中;2:已经结束
  status: number
  // 1是晋级；2是PK, 0:默认值(奖励阶段占用)
  stage_type: number
}
export interface OwnType extends ListItemType {
  promotion_need?: number
  rank_rise_need?: number
}
interface InitialStateType {
  doing_stage?: number
  schedule_list?: Array<ScheduleType>
  list?: Array<ScheduleType>
  broadcasts?: Array<string>
  stage_range?: Array<string>
  group_list?: Array<string>
  group_no?: number
  pk_list?: Array<Array<ListItemType>>
  pk_rank?: Array<ListItemType>
  own_rank?: OwnType
  peroid_list?: Array<string>
  peroid_index?: number
  peroid_count_down?: number
  count_down?: number
}
const initialState: InitialStateType = {}
export const AnnualIndividualPKSlice = createSlice({
  name: 'AnnualIndividualPK',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(yup_stage_list.fulfilled, (state, action) => {
      const {list, ...rest} = action.payload
      // 防止数组返回null，直接重置成[]
      const ret = {
        schedule_list: list || [],
      }
      Object.assign(state, ret, rest)
    })
    builder.addCase(yup_pk_stage.fulfilled, (state, action) => {
      const {pk_list, pk_rank, peroid_list, ...rest} = action.payload
      // 防止数组返回null，直接重置成[]
      const ret = {
        pk_list: pk_list || [],
        pk_rank: pk_rank || [],
        peroid_list: peroid_list || [],
      }
      Object.assign(state, ret, rest)
    })
  },
})
export default AnnualIndividualPKSlice.reducer
